import React from 'react';
import { Link } from 'react-router-dom';
import highlandsImage from '../../assets/neighborhoods/highlands.png';
import dawsonvilleImage from '../../assets/neighborhoods/dawsonville.png';

// This would typically come from an API or database
const neighborhoods = [
  {
    id: 'highlands',
    name: 'The Highlands',
    location: 'Rome, GA',
    description: 'Nestled in the rolling hills of Rome, this beautiful community offers stunning mountain views and easy access to downtown.',
    image: highlandsImage,
    priceRange: 'From the $400s'
  },
  {
    id: 'castleberry',
    name: 'Castleberry Ridge',
    location: 'Dawsonville, GA',
    description: 'Located in charming Dawsonville, this family-friendly neighborhood features spacious lots and excellent schools.',
    image: dawsonvilleImage,
    priceRange: 'From the $450s'
  }
];

const Neighborhoods: React.FC = () => {
  return (
    <div className="container-custom py-12 md:py-24">
      <h1 className="mb-8 text-center">Our Neighborhoods</h1>
      <div className="max-w-5xl mx-auto">
        <p className="text-lg text-gray-700 mb-12 text-center max-w-3xl mx-auto">
          Discover our beautiful communities in prime Georgia locations, designed for modern family living.
        </p>
        
        <div className="grid grid-cols-1 gap-12">
          {neighborhoods.map((neighborhood) => (
            <div key={neighborhood.id} className="bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-xl transition duration-300">
              <div className="md:flex">
                <div className="md:w-1/2">
                  <div className="h-64 md:h-full overflow-hidden">
                    <img 
                      src={neighborhood.image} 
                      alt={neighborhood.name} 
                      className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                    />
                  </div>
                </div>
                <div className="md:w-1/2 p-6 md:p-8 flex flex-col justify-between">
                  <div>
                    <h2 className="text-2xl font-serif mb-1">{neighborhood.name}</h2>
                    <p className="text-primary mb-4">{neighborhood.location}</p>
                    <p className="text-gray-600 mb-6">{neighborhood.description}</p>
                  </div>
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                    <span className="text-primary font-medium mb-4 sm:mb-0">{neighborhood.priceRange}</span>
                    <Link 
                      to={`/neighborhoods/${neighborhood.id}`} 
                      className="btn btn-outline"
                    >
                      View Community
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Neighborhoods; 